export default __webpack_public_path__ + "static/media/28.5b3160f0.png";